
export enum UserAccess {
    None = 0,
    IdtVerified = 1,            // prihlaseny uzivatel s nastavenym IDT
    GdprVerified = 2,           // uzivatel ktery ma overeni dle GDPR
    VerifiedPerson = 4,         // uzivatel ktery je overeny - zamestnanec CSTS
    VerifiedPersonWrite = 8,    // uzivatel ktery je overeny - zamestnanec CSTS - s moznosti zapisu
    Klub = 16,                  // prihlaseny uzivatel je klub clena
}
export const hasUserAccess = (userAccess: UserAccess, required: UserAccess): boolean => ((userAccess & required) !== UserAccess.None);


export enum Resources // !!! musi byt stejne jako Csts.BaseUtils.PermissionsUtils.Resources !!!
{
    Administrator = 1,

    Evidence = 10000,
    Evidence_Clenove = 11000,
    Evidence_Kluby = 12000,
    Evidence_Divize = 13000,
    Evidence_Pary = 14000,
    Evidence_Users = 15000,
    Evidence_Pokladny = 16000,


    Evidence_Users_Seznam = 9915100,
    //Evidence_Users_Seznam_Zobrazit = 9915101,
    //Evidence_Users_Opravneni = 15200,
    Evidence_Users_Role = 9915300,
    //Evidence_Users_Role_Zobrazit = 9915301,
    Evidence_Users_Resources = 9915302,

    Evidence_Pokladny_Stm = 9916001,

    Souteze = 30000,
    Web = 50000,
    Web_Faqs = 9951001,
    Web_Logs = 9952001,
    Web_Ankety = 9953001,

    OverenaOsoba = 9990001,
}
